import styled from "styled-components";

export const InforContainer = styled.div`
  margin-top: 1rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 100%;
  min-height: calc(100% - 1rem);
`;

export const InfoCards = styled.div`
  display: flex;
  gap: 1rem;
  div {
    width: 100%;
  }
`;

// "Tickets sobre o pedido" — centralizado, cor de destaque, igual à imagem
export const TicketsTitle = styled.h3`
  margin: 0;
  font-size: 14px;
  line-height: 150%;
  font-weight: 600;
  color: var(--color-accent);
  text-align: center;
`;

export const EmptyTickets = styled.p`
  margin: 0;
  font-size: 14px;
  line-height: 20px;
  font-weight: 400;
  color: var(--color-text-lighter, #68717a);
  text-align: center;
  padding: 24px 0;
`;

export const TicketsTable = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const TicketsTableRow = styled.div<{ $header?: boolean }>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0;
  border-bottom: 1px solid var(--color-border, #e9ebed);
  font-size: 14px;

  /* Header: sem border-top, com border-bottom */
  ${({ $header }) => $header && `
    border-top: 1px solid var(--color-border, #e9ebed);
  `}

  span:first-child {
    font-weight: ${({ $header }) => ($header ? "600" : "400")};
    color: var(--color-text, #2f3941);
  }

  span:last-child {
    font-weight: ${({ $header }) => ($header ? "600" : "400")};
    color: var(--color-text, #2f3941);
  }
`;

export const TicketLink = styled.a`
  font-size: 14px;
  color: var(--color-accent, #1f73b7);
  text-decoration: none;
  font-weight: 400;

  &:hover {
    text-decoration: underline;
  }
`;